import type { CurrencyNavigationTab } from "./types"

export const CURRENCY_NAVIGATION_TABS = [
  {
    id: "details",
    subpath: "",
  },
  {
    id: "activity",
    subpath: "/activity",
  },
] as const satisfies {
  id: string
  subpath: string
}[]

export const getCurrencyTabById = (
  id: CurrencyNavigationTab["id"],
): CurrencyNavigationTab => {
  const tab = CURRENCY_NAVIGATION_TABS.find(tab => tab.id === id)
  if (!tab) {
    throw new Error(`Currency tab with id ${id} not found`)
  }
  return tab
}
